module.exports = {
    "title": "Estimate",
    "entityName": "estimate",
    "upsert": "full",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "protocol_id",
            "text": "Protocollo",
            "type": "autocomplete",
            "title": "name",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },
        {
            "value": "name",
            "text": "Name",
            "type": "text",
            "title": "name",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },
        {
            "value": "id",
            "text": "ID",
            "title": "ID",
            "table": {
                "sortable": true,
                "filter": true
            },
        },
        {
            "value": 'account_id',
            "render": item => item.account.name + ' ' + item.account.surname,
            "text": "Owner",
            "title": "Owner",
            "table": {
                "sortable": true,
                "filter": true
            },
        },
        {
            "value": "insert_at",
            "text": "Insert at",
            "type": "text",
            "table": {
                "sortable": true,
            },
            "validators": [
                "required",
                (field, value) => value.length <= 2 || `Country max. length is 2`
            ]
        },
        {
            "value": "status",
            "text": "Status",
            "type": "text",
            "table": {
                "sortable": true,
            },
            "validators": [
                "required"
            ]
        },
    ],
    "actions": [
        "upsert", 
        { "value": "clone", "text": "Clone estimate", "color": "primary", "icon": "mdi-content-copy" },
        "remove"
    ]
}